// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28GrN","colBig":"styles_colBig__3wTH1","colSmall":"styles_colSmall__3MfUy"};